// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AmountFieldController from "./amount_field_controller"
application.register("amount-field", AmountFieldController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CsvUploadController from "./csv_upload_controller"
application.register("csv-upload", CsvUploadController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import FormController from "./form_controller"
application.register("form", FormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PocketMoneyFormController from "./pocket_money_form_controller"
application.register("pocket-money-form", PocketMoneyFormController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchableDropdownController from "./searchable_dropdown_controller"
application.register("searchable-dropdown", SearchableDropdownController)

import SlugEditorController from "./slug_editor_controller"
application.register("slug-editor", SlugEditorController)
